import type { SilobagListFilter } from '@siloreal:shared:api/service/silobag/silobag-list';
import * as HOOKS from '@siloreal:shared:hooks';

export type HeaderReportKind = 'combined' | 'silospro' | 'silobag';

export type HeaderReportDefinition = {
  label: string;
  filters: SilobagListFilter;
};

export function getHeaderReportDefinition(kind: HeaderReportKind): HeaderReportDefinition {
  const i18n = HOOKS.useLocale.getState();

  const REPORT_DEFINITIONS = {
    combined: {
      label: `SilosPro + ${i18n.t('temp.common.silobags')}`,
      filters: {},
    },
    silospro: {
      label: 'SilosPro',
      filters: { silobag_data_status_id: 2 },
    },
    silobag: {
      label: i18n.t('temp.common.silobags'),
      filters: { silobag_data_status_id: 1 },
    },
  } as const satisfies Record<HeaderReportKind, HeaderReportDefinition>;

  return REPORT_DEFINITIONS[kind];
}
